import xaxios from '@/xaxios';

export const headers = [
  { text: 'concepto', value: 'xnombre' },
  { text: 'nro. de cuota', value: 'nro_cuota' },
  { text: 'monto', value: 'monto' },
  { text: 'plazo de pago', value: 'fecha_pago' },
  // { text: '', value: 'num_cuota_grupo' },
];

export const rowClassX = (item) => {  
    return item.nro_cuota % 2 == 0 ? 'grupo-par' : 'grupo-impar';
}; 

export const realizar_inscripcion = async (input) => {
  // const url = `${process.env.VUE_APP_API_REST}/api/esam/inscripcion`;
  const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/inscripcion`;
  try {
    const { data } = await xaxios.post(url, input);
    return data;
  } catch (e) {
    return e.response.data;
  }
}

/* export const realizar_preinscripcion = async (input) => {
  const url = `${process.env.VUE_APP_API_REST}/api/esam/preinscripcion`;
  try {
    const { data } = await xaxios.post(url, input);
    return data;
  } catch (e) {
    return e.response.data;
  }
} */

export const realizar_inscripcion_from_preins = async (input) => {
  // const url = `${process.env.VUE_APP_API_REST}/api/esam/preinscripcion`;
  const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/preinscripcion`;
  try {
    const { data } = await xaxios.put(url, input);
    return data;
  } catch (e) { 
    return e.response.data;
  }
}

export const realizar_preinscripcion_from_prospecto = async (input) => {
  const url = `${process.env.VUE_APP_API_REST}/api/esam/preinscripcion`;
  try {
    const { data } = await xaxios.post(url, input);
    return data;
  } catch (e) {
    return e.response.data;
  }
}

export const getprograma = async (id) => {
  const url = `${process.env.VUE_APP_API_REST}/esam/programa/id/` + id;
  const res = await xaxios.get(url);
  return res.data;
};

export const getpromociones = async (idprograma) => {
  const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/programa/${idprograma}/aprobado`;
  const res = await xaxios
    .get(url)
    .then(({ data }) => data)
    .catch((e) => e);
  return res;
};

export const getpromocionesv3 = async (idprograma,p_cobro_prog_id) => { 
  const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/v3/programa/${idprograma}/aprobado?plan_cobro_programa_id=${p_cobro_prog_id}`;
  const res = await xaxios
    .get(url)
    .then(({ data }) => data)
    .catch((e) => e);
  return res;
};


const formatFecha = (date) => {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

const siguienteFecha = (fechaActual) => {
  const d = new Date(fechaActual);
  d.setMonth(d.getMonth() + 1);
  d.setDate(15);
  return d;
};

const sumarMeses = (date, n) => {
  const d = new Date(date);
  d.setMonth(d.getMonth() + n);
  return d;
};

export const generar_plan = (promo, cobros) => {
  // Aplicar descuentos de promocion (clonamos para no mutar el original)
  const cobrosConDescuento = JSON.parse(JSON.stringify(cobros));
  if (promo && promo.detalle_promocion) {
    promo.detalle_promocion.forEach((p) => {
      const ex = cobrosConDescuento.find((c) => c.concepto_id == p.concepto_pago_id);
      if (ex) {
        let desc = 0;
        if (p.is_porcentaje) desc = parseFloat(ex.monto) * (parseInt(p.valor_descuento) / 100);
        else desc = parseFloat(p.valor_descuento);
        ex.monto = parseFloat(ex.monto) - desc;
        ex.promo_descuento = `${p.valor_descuento} ${p.is_porcentaje ? '%' : '$'} descuento`;
      }
    });
  }

  // Fecha de inicio segun el dia de hoy
  const hoy = new Date();
  const fechaInicio = hoy.getDate() > 15 ? new Date(hoy) : (() => { const d = new Date(hoy); d.setDate(15); return d; })();

  const plan = [];
  let ultimaFechaConceptoAnterior = null;

  cobrosConDescuento.forEach((cobro) => {
    const montoTotal = parseFloat(cobro.monto);
    const cuotas = cobro.cuotas;

    // Distribuir monto: division entera, el sobrante va a la primera cuota
    const montoCuota = Math.floor(montoTotal / cuotas);
    const resto = Math.round((montoTotal - montoCuota * cuotas) * 100) / 100;

    // Fecha de inicio para este cobro
    let fechaActual;
    if (cobro.concepto_id === 3) {
      fechaActual = sumarMeses(ultimaFechaConceptoAnterior, 3);
    } else {
      fechaActual = new Date(fechaInicio);
    }

    for (let i = 0; i < cuotas; i++) {
      plan.push({
        cobro_programa_id: cobro.cobro_programa_id,
        // concepto_pago_id: cobro.concepto_id,
        // descuento: 0,
        fecha_pago: formatFecha(fechaActual),
        monto: i === 0 ? montoCuota + resto : montoCuota,
        nro_cuota: i + 1,
        xnombre: cobro.nombre,
      });

      if (i < cuotas - 1) {
        fechaActual = siguienteFecha(fechaActual);
      }
    }

    // Guardar ultima fecha de este concepto para el concepto_id=3
    if (cobro.concepto_id !== 3) {
      ultimaFechaConceptoAnterior = new Date(fechaActual);
    }
  });

  return {
    plan,
    plan_con_descuentos: cobrosConDescuento,
  };
};
